import React, { useContext, useState, useMemo } from 'react';

import BreadcrumbsContext from './BreadcrumbsContext';

export const BreadcrumbProvider = ({
  title: initialTitle,
  link,
  icon,
  linkable,
  children,
}) => {
  const { current: previous } = useContext(BreadcrumbsContext);
  const [title, setTitle] = useState(initialTitle);
  const [params, setParams] = useState(null);

  const current = useMemo(
    () => [...previous, { title, icon, link, linkable, params }],
    [previous, title, icon, link, linkable, params]
  );

  return (
    <BreadcrumbsContext.Provider
      value={{
        previous: previous,
        current: current,
        icon: icon,
        title: title,
        setTitle: setTitle,
        setParams,
        params,
      }}
      children={children}
    />
  );
};
